package dev.codetwister.ctdev

import androidx.compose.ui.graphics.Color

internal val BgDark = Color(0xFF0E0A12)
internal val BgCard = Color(0xFF14141F)
internal val BgCardBorder = Color(0xFF1E1E30)
internal val TextPrimary = Color(0xFFE0E0E0)
internal val TextWhite = Color(0xFFFFFFFF)
internal val TextMuted = Color(0xFF8A8A9A)
internal val TextFooter = Color(0xFF555555)
internal val Green = Color(0xFF5CFF5C)
internal val Blue = Color(0xFF38BDF8)
internal val Orange = Color(0xFFF97316)
internal val Red = Color(0xFFEF4444)

